module.exports = __webpack_public_path__ + "img/Rectangle@2x.6ff7b9a2.png";